import React, { ReactElement } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { ToastContainer } from "react-toastify";
import "./page.scss";
import { UtilService } from '../../services/UtilService';
interface IProps {
    children: ReactElement;
    t: TFunction
}

interface IState {
}

class Page extends React.Component<IProps, IState> {

    render() {
        const { t } = this.props;
        return (
            <div className="page-container" >
                <div {...UtilService.isMobilePlatform() ? { className: "container-fluid" } : { className: "container-fluid main-container" }}>
                    <ToastContainer autoClose={3000} ></ToastContainer>
                    <div className="page-header"></div>
                    {this.props.children}
                </div>
            </div>
        )
    };

}

export default withTranslation()(Page);
